import { Component, OnInit, Optional, Inject } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ListPersonasService } from './services/list-personas.service';
import { IListaPersonasRequest, IPersonaDetalle } from './interfaces/list-personas.interface';
import Swal from 'sweetalert2';
import { AbcListaPersonasDialogComponent } from './abc-lista-personas-dialog/abc-lista-personas-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-abc-lista-personas',
  templateUrl: './abc-lista-personas.component.html',
  providers: [ConfirmationService, MessageService, DialogService]
})
export class AbcListaPersonasComponent implements OnInit {
  personas: any[] = [];
  loading: boolean = true;
  globalFilter: string = '';
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  dataSource: any[] = [];
  ref: DynamicDialogRef;
  columns: any[] = [
    { field: 'numero_cliente', header: 'Número Cliente' },
    { field: 'nombre_completo', header: 'Nombre Completo' },
    { field: 'fechaAltaFormateada', header: 'Fecha Alta' },
    { field: 'actions', header: 'Acciones' }
  ];
  modoActividad: boolean = false;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<AbcListaPersonasComponent>,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private listPersonasService: ListPersonasService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.loadPersonas();
  }

  loadPersonas(): void {
    this.loading = true;
    const request: IListaPersonasRequest = {
      que: 4,
      tope: "999",
      cmd: "",
      numero_cliente: "",
      primer_nombre: "",
      segundo_nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      sFechaNacimiento: "",
      calle: "",
      numero_exterior: "",
      colonia: "",
      ciudad: "",
      del_muni: "",
      estado: "",
      cp: 0,
      empresa: "",
      telefono: "",
      telefono2: "",
      rfc: "",
      cedula: "",
      lnegodbc: 0,
      compania: ""
    };

    this.listPersonasService.getListPersonas(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data.map(persona => {
            return {
              ...persona,
              nombre_completo: `${persona.primer_nombre} ${persona.segundo_nombre || ''} ${persona.apellido_paterno} ${persona.apellido_materno}`.trim()
            };
          });
          console.log('Datos cargados:', this.dataSource);
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar la lista de personas'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar la lista de personas'
        });
        this.loading = false;
      }
    });
  }

  nuevo(): void {
    const dialogRef = this.dialog.open(AbcListaPersonasDialogComponent, {
      width: '70%',
      disableClose: true,
      panelClass: ['dialog-persona']
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadPersonas(); // Recargar la tabla después de crear
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Persona creada correctamente'
        });
      }
    });
  }

  editar(persona: any): void {
    const request: IListaPersonasRequest = {
      que: 5,
      tope: "",
      cmd: "",
      numero_cliente: "",
      primer_nombre: "",
      segundo_nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      sFechaNacimiento: "",
      calle: "",
      numero_exterior: "",
      colonia: "",
      ciudad: "",
      del_muni: "",
      estado: "",
      cp: 0,
      empresa: "",
      telefono: "",
      telefono2: "",
      rfc: "",
      cedula: "",
      lnegodbc: persona.lnegodbc,
      compania: ""
    };

    this.listPersonasService.editPersona(request).subscribe({
      next: (response) => {
        if (response.success && response.data.length > 0) {
          const personaDetalle: IPersonaDetalle = response.data[0];
          
          const dialogRef = this.dialog.open(AbcListaPersonasDialogComponent, {
            width: '70%',
            disableClose: true,
            panelClass: ['dialog-persona'],
            data: {
              ...personaDetalle,
              fechaAltaFormateada: persona.fechaAltaFormateada
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.loadPersonas();
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Persona actualizada correctamente'
              });
            }
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se encontraron los datos de la persona'
          });
        }
      },
      error: (error) => {
        console.error('Error al obtener detalles de la persona:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los datos de la persona'
        });
      }
    });
  }

  delete(persona: any): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: "¿Desea eliminar esta persona?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const request: IListaPersonasRequest = {
          que: 3,
          tope: "",
          cmd: "",
          numero_cliente: persona.numero_cliente,
          primer_nombre: "",
          segundo_nombre: "",
          apellido_paterno: "",
          apellido_materno: "",
          sFechaNacimiento: "",
          calle: "",
          numero_exterior: "",
          colonia: "",
          ciudad: "",
          del_muni: "",
          estado: "",
          cp: 0,
          empresa: "",
          telefono: "",
          telefono2: "",
          rfc: "",
          cedula: "",
          lnegodbc: persona.lnegodbc,
          compania: ""
        };

        this.listPersonasService.deletePersona(request).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Persona eliminada correctamente'
              });
              this.loadPersonas(); // Recargar la lista
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar la persona'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Ocurrió un error al eliminar la persona'
            });
          }
        });
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  onFilter(event: any): void {
    this.globalFilter = event.filteredValue;
  }

    close(): void {
    if (this.data?.onClose) {
      this.data.onClose();
    }
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
} 